<template>
  <div class="playlist-track-removing">
    <Modal v-if="open" class="mk-modal" @close="close">
      <slot>
        <div class="title">
          {{ $t('TRACK.REMOVE_TRACK') }}
        </div>
        <div class="desp">
          {{
            $t('PLAYLIST.REMOVE_TRACK_FROM_PLAYLIST', { playlist: displayLocaleTitle(playlist), track: displayTrackName(selectedTrack)})
          }}
        </div>
        <div class="btn-group">
          <a :class="{'loading': loading}" class="mk-btn mk-btn--danger" title="remove" @click="remove">
            {{ $t('COMMON.REMOVE') }}
          </a>
          <a class="mk-btn mk-btn--secondary" title="cancel" @click="close">
            {{ $t('COMMON.CANCEL') }}
          </a>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import PlaylistService from '@/assets/services/PlaylistService'
import { displayLocaleTitle } from '@/assets/helpers/PlaylistHelper'
import { displayTrackName } from '@/assets/helpers/TrackHelper'

export default {
  name: 'PlaylistTrackRemovingingModal',
  components: {
    Modal
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    playlist: {
      type: Object,
      default: () => {}
    },
    selectedTrack: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayLocaleTitle,
    displayTrackName,
    close() {
      this.$emit('close')
    },
    async remove() {
      this.loading = true
      const trackId = this.selectedTrack.id
      const playlistId = this.playlist.id
      const res = await PlaylistService.removeTrackFromPlaylist(trackId, playlistId)
      if (res) {
        this.$store.commit('ALERT_MESSAGE', { message: 'TRACK.REMOVE_FROM_PLAYLIST_SUCCESS', type: 'success' })
        await this.$store.dispatch('UPDATE_USER_PLAYLIST')
        this.$emit('close', trackId)
      } else {
        this.$store.commit('ALERT_MESSAGE', { message: 'TRACK.REMOVE_FROM_PLAYLIST_ERROR', type: 'error' })
      }
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/variables.scss';
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
